/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_ShopInputs */

const en_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const zh_hans1_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电商`)
};

const pt_br2_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const es_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const fr_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

const de_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Commerce`)
};

const ru_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная коммерция`)
};

const it_category_shop = /** @type {(inputs: Category_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce`)
};

/**
* | output |
* | --- |
* | "E-commerce" |
*
* @param {Category_ShopInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_shop = /** @type {((inputs?: Category_ShopInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_ShopInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_shop(inputs)
	if (locale === "pt-BR") return pt_br2_category_shop(inputs)
	if (locale === "es") return es_category_shop(inputs)
	if (locale === "fr") return fr_category_shop(inputs)
	if (locale === "de") return de_category_shop(inputs)
	if (locale === "ru") return ru_category_shop(inputs)
	if (locale === "it") return it_category_shop(inputs)
	return en_category_shop(inputs)
});